import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease-in-out;
  opacity: 1;
  animation: show 0.3s ease-in-out;
  z-index: 1200;
  padding: 1rem;
  overflow: hidden;

  @keyframes show {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

type PropsContent = {
  mxheight?: string;
  height?: string;
};

export const Content = styled.div<PropsContent>`
  width: 90%;
  max-width: 800px;
  max-height: ${(prop) => {
    if (prop.mxheight) return `${prop.mxheight}px`;
    if (prop.height) return `${prop.height}px`;
    return '85vh';
  }};
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(0, 0, 0, 0.05);
  z-index: 9000;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: showModal 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .content-button-init-modal {
    display: flex;
    gap: 1rem;
    width: 100%;
    padding: 1rem 0;
  }

  @keyframes showModal {
    0% {
      opacity: 0;
      transform: scale(0.95) translateY(-20px);
    }
    100% {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }

  @media screen and (max-width: 760px) {
    width: 95%;
    max-height: 90vh;
  }


`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1.5rem 2rem;
  background: linear-gradient(135deg, #254d6b 0%, #1a3a52 100%);
  color: #fff;
  border-radius: 16px 16px 0 0;

  h4 {
    font-weight: 600;
    font-size: 1.25rem;
    margin: 0;
    color: #fff;
    letter-spacing: 0.02em;
  }

  span {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 0.1);
    transition: all 0.2s ease;
    color: #fff;

    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
      transform: rotate(90deg);
    }

    svg {
      width: 20px;
      height: 20px;
      color: #fff;
      fill: #fff;
      stroke: #fff;
    }
  }

  @media screen and (max-width: 760px) {
    padding: 1.25rem 1.5rem;

    h4 {
      font-size: 1.1rem;
    }
  }
`;

export const BoxInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  flex: 1;
  padding: 2rem;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  background-color: #fafafa;
  min-height: 0;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #aaa;
    }
  }

  @media screen and (max-width: 760px) {
    padding: 1.5rem 1rem;
    max-height: calc(90vh - 80px);
    -webkit-overflow-scrolling: touch;
  }
`;

type ImgProp = {
  src: any;
};

export const Img = styled.img<ImgProp>`
  width: 100%;
  max-height: 320px;
  margin-bottom: 10px;
  border-radius: 8px;

  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    background-image: url(${(prop) => prop.src});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
  }
`;

export const InfoProd = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0;
  border-radius: 5px;
  flex: 1;
  width: 100%;

  h4 {
    font-weight: 600;
    font-size: 1.2rem;
    margin-bottom: 1rem;
    color: #254d6b;
  }

  div {
    color: #444;
    line-height: 1.6;
  }

  p {
    font-size: 1.3rem;
    margin: 15px 0 25px 0;
    color: #333;
  }
`;

export const Footer = styled.footer`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 10px 0px 0px;
  border-top: 1px solid #ebebeb;

  /* div {
        padding: 8px 15px;
        background-color: #f1f2f3;
        border: 1px solid #ccc;
        border-radius: 4px;
        cursor: pointer;

        &:hover {
            background-color: #eeebeb;
        }
    } */
  .QtdSendCard {
    margin-right: 1rem;
    display: flex;
    align-items: center;

    button {
      height: 2rem;
      width: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      background-color: transparent;
    }
    span {
      height: 2rem;
      width: 3rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 0.5rem;
      border: 1px solid #bbb;
      border-radius: 5px;
    }
  }

  & button.AddCart {
    display: flex;
    background-color: #16c521;
    border: none;
    border-radius: 5px;
    overflow: hidden;
    align-items: center;
    padding-left: 0.5rem;
    color: #fff;

    div {
      background-color: rgba(46, 125, 50, 1);
      display: flex;
      align-items: center;
      height: 2rem;
      justify-content: center;
      margin-left: 0.5rem;

      span {
        margin: 0px 0.5rem;
      }
    }
  }
`;

export const BoxCart = styled.div`
  margin-left: auto;
  height: 5px;
`;
